document.addEventListener('DOMContentLoaded', function () {
  const tablinks = document.querySelectorAll('.tablinks[data-tab]');
  if (!tablinks.length) return;

  function openTab(tabName, activeBtn) {
    document.querySelectorAll('.tabcontent').forEach(el => { el.style.display = 'none'; });
    document.querySelectorAll('.tablinks').forEach(el => { el.classList.remove('active'); });
    const tab = document.getElementById(tabName);
    if (tab) tab.style.display = 'block';
    if (activeBtn) activeBtn.classList.add('active');
  }

  tablinks.forEach(btn => {
    btn.addEventListener('click', function () {
      openTab(this.dataset.tab, this);
    });
  });

  // Ouvre le premier onglet par défaut
  const defaultBtn = document.getElementById('defaultOpen');
  if (defaultBtn) defaultBtn.click();
});
